import Joi from 'joi';

import { IWaterEffectSectionProps } from './models';

const stringRequired = Joi.string().required();
const stringOptional = Joi.string().optional();
const uriRequired = Joi.string().uri().required();
const imgSchema = {
  url: uriRequired,
  filename: Joi.string().required(),
};
const requiredImageSchema = Joi.object(imgSchema).required();

export const waterEffectSectionSchema = Joi.object<IWaterEffectSectionProps>({
  title: stringRequired,
  descriptionTop: stringOptional,
  descriptionBottom: stringOptional,
  imageAlt: stringRequired,
  image: requiredImageSchema,
  imageBg: requiredImageSchema,
  imageBgAlt: stringRequired,
  imageBgMobile: requiredImageSchema,
  imageBgMobileAlt: stringRequired,
}).options({ stripUnknown: true });
